import React from 'react';
import { Container, Row, Col, Form, Button, FormCheck } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';

const PaytaskForm = () => {
  return (
    <Container className="mt-4" style={{ maxWidth: '600px', marginLeft: '0px' }}>
      <Row className="justify-content-left">
        <Col md={12}>
          <h2 className="text-left mb-4 text-dark">Parameters</h2>
          <Form className="p-4 border rounded" style={{ borderTop: '5px solid rgb(0, 123, 255)' }}>
            {/* Start Date Input */}
            <Form.Group as={Row} controlId="pay-per-task-start-date">
              <Form.Label column md={4}>
                Start Date <span className="text-danger">*</span>
              </Form.Label>
              <Col md={8}>
                <Form.Control 
                  type="date" 
                  name="start_date" 
                  required 
                  defaultValue="2024-09-01" 
                />
              </Col>
            </Form.Group>

            {/* End Date Input */}
            <Form.Group as={Row} controlId="pay-per-task-end-date">
              <Form.Label column md={4}>
                End Date <span className="text-danger">*</span>
              </Form.Label>
              <Col md={8}>
                <Form.Control 
                  type="date" 
                  name="end_date" 
                  required 
                  defaultValue="2024-09-30" 
                />
              </Col>
            </Form.Group>

            {/* Accounts Selection */}
            <Form.Group as={Row} controlId="pay_per_task_practice">
              <Form.Label column md={4}>Accounts</Form.Label>
              <Col md={8}>
                <Form.Select 
                  name="practice" 
                  id="pay_per_task_practice"
                >
                  <option value="0">All</option>
                  <option value="144545">2ingis s.a.</option>
                  <option value="71159">ALL SAINTS DENTAL</option>
                  <option value="71160">ALLESLEY PARK DENTAL PRACTICE</option>
                  <option value="71209">ALTMORE DENTAL PRACTICE</option>
                  <option value="137334">Andrew Lee (Diu Resh)</option>
                  <option value="110831">Andrew Lee Dental (Bardha Jas)</option>
                  <option value="109766">Andrew Lee Dental (Roebuck Louise)</option>
                  <option value="109767">Andrew Lee Dental (T Hyare)</option>
                  <option value="108890">Andrew Lee Dental Practice</option>
                  <option value="108928">Arminder Sohal (111 Sandwell Road)</option>
                  <option value="71161">ASCENT (TAMWORTH DENTAL)</option>
                  <option value="75815">ASCENT DENTAL CARE SOLIHULL</option>
                  <option value="7675">Aviva Cosmetic Dentistry Ltd.</option>
                  <option value="71163">AVONDALE HOUSE DENTAL SURGERY</option>
                  <option value="131695">Balkrishna Dental Practice</option>
                  <option value="110701">Balsall Common Dental Practice</option>
                  <option value="105909">Bankton Dental Practice</option>
                  <option value="131955">Swissmeda(Dental 22)</option>
                  <option value="131093">Swissmeda(Dental Beauty Battersea)</option>
                  <option value="135963">Swissmeda(Dental Beauty Battersea)</option>
                  <option value="113966">Winn Dental Laboratory</option>
                  <option value="88036">Wood End Dental Surgery</option>
                </Form.Select>
                <FormCheck 
                  type="checkbox" 
                  name="include_closed" 
                  value="1" 
                  label="Include Closed" 
                  className="mt-2"
                />
              </Col>
            </Form.Group>

            {/* Account Tags */}
            <Form.Group as={Row} controlId="report_pay_per_task_account_tags">
              <Form.Label column md={4}>Account Tags</Form.Label>
              <Col md={8}>
                <Form.Select 
                  name="tags"
                >
                  <option value="">No filter</option>
                  <option value="a-practices">a-practices</option>
                  <option value="bhandal">bhandal</option>
                  <option value="coventry-dental">coventry-dental</option>
                  <option value="dental-beauty">dental-beauty</option>
                  <option value="murray-dental-">murray-dental-</option>
                  <option value="swissmeda">swissmeda</option>
                </Form.Select>
              </Col>
            </Form.Group>

            {/* Format Selection */}
            <Form.Group as={Row} controlId="report_pay_per_task_format">
              <Form.Label column md={4}>
                Format <span className="text-danger">*</span>
              </Form.Label>
              <Col md={8}>
                <Form.Select name="format">
                  <option value="">On Screen</option>
                  <option value="csv">CSV (Excel)</option>
                </Form.Select>
              </Col>
            </Form.Group>

            {/* Submit Button */}
            <Form.Group as={Row}>
              <Col sm={{ span: 8, offset: 4 }}>
                <Link to="/AddpayperDetails">
                  <Button
                    id="pay-per-task-submit"
                    type="button"
                    variant="primary"
                    className="w-100 mt-2"
                    style={{
                      backgroundColor: '#004aad',
                      borderColor: '#004aad',
                      marginTop: '10px',
                    }}
                  >
                    Run
                  </Button>
                </Link>
              </Col>
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default PaytaskForm;
